import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/ui/button";
import { useLanguage } from "../context/LanguageContext";
import emailIcon from "../assets/images/icons/AboutVox/email.png";
import scanCardIcon from "../assets/images/icons/AboutVox/scan-card.png";
import enablerIcon from "../assets/images/icons/AboutVox/enabler.png";
import number1 from "../assets/images/icons/AboutVox/1.png";
import number2 from "../assets/images/icons/AboutVox/2.png";
import number3 from "../assets/images/icons/AboutVox/3.png";
import writeIcon from "../assets/images/icons/AboutVox/write.png";
import { useTenant } from "../context/TenantContext";

const AboutVoxPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { tenant } = useTenant();

  return (
    <>
      <div className="max-w-md lg:max-w-6xl mx-auto p-4 lg:p-8 space-y-6 lg:space-y-8">
        {/* Header */}
        <div className="font-bold text-base lg:text-2xl space-y-1 text-left lg:text-center flex items-center justify-start lg:justify-center gap-2">
          <img
            src={writeIcon}
            alt="Write icon"
            className="w-4 h-4 lg:w-6 lg:h-6"
          />
          <p>{t("aboutVox.title")}</p>
        </div>

        {/* Description */}
        <div className="text-xs lg:text-base space-y-1 text-center max-w-4xl mx-auto">
          <p>{t("aboutVox.introText")}</p>
          <div className="font-bold pt-2">{t("aboutVox.importantNotice")}</div>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 pt-4">
          {/* Step 1 */}
          <div className="space-y-3 lg:space-y-4 text-center flex flex-col items-center">
            <div className="flex justify-center items-center relative">
              <img
                src={emailIcon}
                alt="Email icon"
                className="w-[66px] h-[66px] object-contain "
              />
              <img
                src={number1}
                alt="Number1 icon"
                className="w-[37px] h-[83px] object-contain absolute"
                style={{
                  left: "-25px",
                }}
              />
            </div>
            <div className="space-y-1 lg:space-y-2">
              <div className="font-bold text-base lg:text-xl">
                {t("aboutVox.step1Title")}
              </div>
              <div className="font-normal text-xs lg:text-sm">
                {t("aboutVox.step1Description01")}{" "}
                <span
                  className="text-theme-primary cursor-pointer hover:underline"
                  onClick={() =>
                    navigate(`/${tenant?.tenanturlname}/create-account`)
                  }
                >
                  {t("aboutVox.signup")}
                </span>
                {t("aboutVox.step1Description02")}
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-3 lg:space-y-4 text-center flex flex-col items-center mb-4">
            <div className="flex justify-center items-center relative">
              <img
                src={scanCardIcon}
                alt="Scan Card icon"
                className="w-[66px] h-[66px] object-contain "
              />
              <img
                src={number2}
                alt="Number2 icon"
                className="w-[67px] h-[85px] object-contain absolute"
                style={{
                  left: "55px",
                }}
              />
            </div>
            <div className="space-y-1 lg:space-y-2">
              <div className="font-bold text-base lg:text-xl">
                {t("aboutVox.step2Title")}
              </div>
              <div className="font-normal text-xs lg:text-sm">
                {t("aboutVox.step2Description")}
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="space-y-3 lg:space-y-4 text-center flex flex-col items-center">
            <div className="flex justify-center items-center relative">
              <img
                src={enablerIcon}
                alt="Enabler icon"
                className="w-[66px] h-[66px] object-contain "
              />
              <img
                src={number3}
                alt="Number3 icon"
                className="w-[69px] h-[87px] object-contain absolute"
                style={{
                  left: "-50px",
                  bottom: "3px",
                }}
              />
            </div>
            <div className="space-y-1 lg:space-y-2">
              <div className="font-bold text-base lg:text-xl lg:w-[200px] lg:mx-auto">
                {t("aboutVox.step3Title")}
              </div>
              <div className="font-normal text-xs lg:text-sm">
                {t("aboutVox.step3Description")}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Notes */}
        <div className="text-gray-500 text-xs lg:text-sm space-y-1 text-left lg:text-center max-w-4xl mx-auto pt-4">
          <p>{t("aboutVox.footerNote1")}</p>
          <div className="h-3" />
          <p>{t("aboutVox.footerNote2")}</p>
        </div>

        {/* New Home Button Design */}
        <div className="pt-2 lg:w-[261px] mx-auto">
          <Button
            id="home-btn"
            variant="secondary"
            size="lg"
            type="button"
            onClick={() => navigate(`/${tenant.tenanturlname}`)}
          >
            <div className="flex items-center gap-2">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-house-icon lucide-house"
                >
                  <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                  <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                </svg>
              </div>
              <span>{t("mainLayout.home")}</span>
            </div>
          </Button>
        </div>
      </div>
    </>
  );
};

export default AboutVoxPage;
